import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

type LatLngProps = {
    lat: number,
    lng: number
}

type MapaProps = {
    center: LatLngProps,
    markers: LatLngProps[],
    width?: string,
    height?: string
}

export default function MapaGoogle({center, markers, width, height}: MapaProps) {
    const containerStyle = {
        width: width ? width : '100%',
        height: height ? height: '500px'
    };

    return (
        <>
            <LoadScript
                googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY ?? ''}
            >
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={15}
                >
                    
                    <>
                        {markers?.map((marker) => (
                            <>
                                <Marker key={`marker${marker.lat}`} position={{ lat: marker.lat, lng: marker.lng }} />
                            </>
                        ))}
                    </>
                </GoogleMap>
            </LoadScript>
        </>
    )
}